import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { MenuService } from '../../services/menu.service'; 
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {
 
  url: SafeResourceUrl;

  constructor(public sanitizer:DomSanitizer,
    private menuService: MenuService,
    private authService: AuthService,
    private route: ActivatedRoute ){}

  ngOnInit(): void {  
    this.route.params.subscribe(async params => {
      const route = params['route'];
      const title = params['title'];
      this.menuService.setMenuTitle(title);
      this.url = this.sanitizer
      .bypassSecurityTrustResourceUrl(this.authService.getSettingsUrl() + route);      
    }); 
  } 
}
